import App from './components/app'
import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider } from '@intelie/ui'
import liveTheme, { mergeIntelieUiTheme } from 'live/services/theme'

import { HashRouter as Router, Route, Switch } from 'react-router-dom'

import Main from './components/main'
import { Provider } from 'react-redux'
import store from './lib/store'
import { SpreadsheetHeader } from './components/main/SpreadSheetHeader'
import GroupDatabase from './components/GroupDatabase'
import SftpGroupDatabase from './components/SftpGroupDatabase'
import S3GroupDatabase from './components/S3GroupDatabase'

export const LiveSpreadsheets = (): void => {
    ReactDOM.render(
        <Provider store={store}>
            <Router>
                <ThemeProvider cssVarsSelector=":root" themeMerger={mergeWithLiveTheme}>
                    <App className={'live-spreadsheets'}>
                        <SpreadsheetHeader />
                        <Switch>
                            <Route exact path="/" component={Main} />
                            <Route exact path="/groups" component={GroupDatabase} />
                            <Route exact path="/groups-sftp" component={SftpGroupDatabase} />
                            <Route exact path="/groups-s3" component={S3GroupDatabase} />
                            <Route path="/:uid" component={Main} />
                        </Switch>
                        <div></div>
                    </App>
                </ThemeProvider>
            </Router>
        </Provider>,
        document.getElementById('main-content')
    )
}

const mergeWithLiveTheme = theme => {
    const merged = mergeIntelieUiTheme(theme, liveTheme)

    return merged
}
